import { JsonFormPropertyV2 } from '../component-library/FormComponent/types'

/* eslint-disable @typescript-eslint/no-explicit-any */
export function getMatchingFilters(
  filtersSelectionsPersisted: Record<string, any>[],
  pageFilters: { id: string; type: string; pinned?: string }[]
): Record<string, any>[] {
  // Extract all IDs from pageFilters
  const pageFilterIds = pageFilters.map((filter) => filter.id)

  // Filter the filtersSelectionsPersisted array
  return filtersSelectionsPersisted.filter((filterObj) => {
    // Get the first (and only) key from the object
    const key = Object.keys(filterObj)[0]

    // Check if this key exists in pageFilterIds
    return pageFilterIds.includes(key)
  })
}

export function updateFiltersSelections(
  filtersSelectionsPersisted: Record<string, any>[],
  selections: Record<string, any>[]
): Record<string, any>[] {
  // Create a deep copy of filtersSelectionsPersisted to avoid mutation
  const updatedFilters = [...filtersSelectionsPersisted]

  // Set of keys already in filtersSelectionsPersisted
  const existingKeys = new Set(filtersSelectionsPersisted.map((obj) => Object.keys(obj)[0]))

  // Find selections that don't exist in filtersSelectionsPersisted
  const newSelections = selections.filter((selectionObj) => {
    const key = Object.keys(selectionObj)[0]
    return !existingKeys.has(key)
  })

  // Add the new selections to updatedFilters
  return [...updatedFilters, ...newSelections]
}

export function getDefaultTileFilterSelections(properties: JsonFormPropertyV2[]): Record<string, any>[] {
  const selections = properties
    .filter((property) => property.default)
    .map((property) => {
      return {
        [property.id]: property.default,
      }
    })
  return selections
}
